import React from 'react';
import { useTranslation } from 'react-i18next';
import { ServiceVideo } from '../../types';
import styles from './VideoGallery.module.css';

interface VideoGalleryProps {
  videos: ServiceVideo[];
  accentColor?: string;
}

const VideoGallery: React.FC<VideoGalleryProps> = ({ videos, accentColor }) => {
  const { t } = useTranslation();

  if (videos.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>{t('services.videosTitle')}</h2>
        <div className={styles.grid}>
          {videos.map((video) => (
            <div key={video.id} className={styles.videoCard}>
              <div className={styles.videoWrapper}>
                <video
                  controls
                  preload="metadata"
                  poster={video.poster}
                  className={styles.video}
                >
                  <source src={video.src} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className={styles.videoInfo}>
                <h3
                  className={styles.videoTitle}
                  style={accentColor ? { color: accentColor } : undefined}
                >
                  {t(video.titleKey)}
                </h3>
                {video.descriptionKey && (
                  <p className={styles.videoDescription}>
                    {t(video.descriptionKey)}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoGallery;
